import { MOSCOW_ID, SPB_ID } from 'shared/constants/regions';
import { updateCity } from 'shared/slices/geo';
import { updateGeoLocation, updateRegion } from 'shared/thunks/jsonQuery';
import { updateSearchMeta } from 'shared/thunks/searchMeta';
import { ILocation } from 'shared/types/location';
import { TAsyncThunkAction } from 'shared/types/redux';

export const selectCity =
  (city: ILocation): TAsyncThunkAction =>
  async dispatch => {
    dispatch(updateCity(city));
    dispatch(updateRegion(city));

    /**
     * @description
     * Отдельно обрабатываем небольшие города внутри крупных городов (Москва, Санкт-Петербург)
     * Это нужно, чтобы мета корректно вернула данные.
     * Например, Троицк в Москве или Павловск в Санкт-Петербурге.
     */
    if (city.parentId && [MOSCOW_ID, SPB_ID].includes(city.parentId)) {
      dispatch(updateGeoLocation(city));
    }

    dispatch(updateSearchMeta());
  };
